import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1016 2.96875H5.89844C5.58764 2.96875 5.28957 3.09221 5.0698 3.31198C4.85003 3.53175 4.72656 3.82982 4.72656 4.14062V17.0312C4.72661 17.1358 4.75465 17.2385 4.80776 17.3285C4.86087 17.4186 4.93711 17.4928 5.02858 17.5435C5.12006 17.5942 5.22342 17.6195 5.32795 17.6167C5.43248 17.6139 5.53437 17.5833 5.62305 17.5278L10 14.7922L14.3777 17.5278C14.4663 17.5831 14.5682 17.6136 14.6726 17.6162C14.777 17.6189 14.8802 17.5936 14.9716 17.543C15.063 17.4923 15.1391 17.4182 15.1922 17.3282C15.2452 17.2382 15.2733 17.1357 15.2734 17.0312V4.14062C15.2734 3.82982 15.15 3.53175 14.9302 3.31198C14.7104 3.09221 14.4124 2.96875 14.1016 2.96875Z",
		fill: "currentColor"
	})
});
export default SvgBookmarkFill;
